import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { tzmoment } from 'lib/tzmoment';
import { BerthClosuresDashboard, BerthClosureViewModel, Columns } from './model';
import { ActionsMenuButton } from 'portcall/actionsmenubutton/view';
import { DateRangeSelectorView } from 'portcall/daterangeselector/view';
import { DownloadLink } from 'portcall/downloadlink/view';
import { GridTableHeaderCells, GridTableRowCells } from 'portcall/gridcomponents/view';
import { PageLoadingIndicator } from 'core/actionloadingindicator/view';
import { PCDismissible } from 'portcall/pcdismissible/view';

export const BerthClosuresDashboardView = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="berth-closures-dashboard">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" onClick={noDefault(() => window.history.back())}>&lt;&lt; Back</a>
            <ActionsMenuButton onClick={() => m.ShowActionsMenu(!m.ShowActionsMenu())} />
            <ActionsContainer model={m} />
        </div>
        <ProfileHeader model={m} />
        <ControlsView model={m} />
        <PageLoadingIndicator loading={m.Loading} />
        <ClosuresTable model={m} />
    </div>
);

const ActionsContainer = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="pc-actions">
        {m.ShowActionsMenu() &&
            <PCDismissible className="pc-card pc-actions-menu" onDismiss={() => m.ShowActionsMenu(false)}>
                <PrintMenuItem model={m} />
                <CSVExportMenuItem model={m} />
            </PCDismissible>
        }
    </div>
);

const PrintMenuItem = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="action-item">
        <div>
            <a
                href=""
                onClick={noDefault(() => {
                    m.ShowActionsMenu(false);
                    window.print();
                })}
            >Print Report</a>
        </div>
        <div className="pc-text-smalllabel pc-action-item-descr">
            Print the current view's results.
        </div>
    </div>
);

const CSVExportMenuItem = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="action-item">
        <div>
            <DownloadLink
                href={m.CSVExportLink()}
                download="closures.csv"
                onClick={() => m.ShowActionsMenu(false)}
            >
                Export to CSV
            </DownloadLink>
        </div>
        <div className="pc-text-smalllabel pc-action-item-descr">
            Save the current view's results as a CSV, which can be used in Excel.
        </div>
    </div>
);

const ProfileHeader = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="profile-header">
        {m.Organization() && <img src={m.Organization()!.Image.ProfileUrl() || ''} />}
        <div className="profile-header-details">
            <div className="name pc-text-fixedwidth">{m.Organization() && m.Organization()!.Name()}</div>
        </div>
    </div>
);

const ControlsView = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <div className="controls pc-search-mobile">
        <div className="title">Berth Closures</div>
        <input
            className="pc-reports-filter"
            placeholder="Filter By &mdash;"
            value={m.Filter()}
            onChange={e => m.Filter(e.currentTarget.value)}
        />
        <DateRangeSelectorView model={m.DateRangeSelector} />
    </div>
);

const ClosuresTable = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <table className="table">
        <TableHead model={m} />
        <TableBody model={m} />
    </table>
);

const TableHead = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <thead>
        <tr>
            {GridTableHeaderCells(Columns, m.RowSorter)}
            <th className="actions">{/* Empty header cell */}</th>
        </tr>
    </thead>
);

const TableBody = SuperCritical(({ model: m } : { model : BerthClosuresDashboard }) =>
    <tbody>
        {m.Closures().map(closure =>
            <TableRow closure={closure} key={closure.Model.Id()} />
        )}
    </tbody>
);

const TableRow = SuperCritical(({ closure } : { closure : BerthClosureViewModel }) =>
    <tr>
        {GridTableRowCells(Columns, closure)}
        <td className="actions">
            <a
                href=""
                className="fa fa-bars actions-link"
                onClick={noDefault(() => closure.ShowActionsMenu(!closure.ShowActionsMenu()))}
            />
            <RowActionsMenu closure={closure} />
        </td>
    </tr>
);

const RowActionsMenu = SuperCritical(({ closure } : { closure : BerthClosureViewModel }) =>
    closure.ShowActionsMenu() ?
        <PCDismissible className="pc-card actions-menu" onDismiss={() => closure.ShowActionsMenu(false)}>
            <div className="action-item">
                <a
                    href={`#!schedulegrid?bclid=${closure.Model.Id()}&date=${tzmoment(closure.Model.StartDate()).add(-1, 'days').format('YYYY-MM-DD')}`}
                >
                    View on berths
                </a>
            </div>
        </PCDismissible> :
        null
);



// WEBPACK FOOTER //
// ./apps/portcall/berthclosuresdashboard/view.tsx